var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadcastGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 7.33317C8.7367 7.33317 9.33366 6.73622 9.33366 5.99984C9.33366 5.26346 8.7367 4.6665 8.00033 4.6665C7.26395 4.6665 6.66699 5.26346 6.66699 5.99984C6.66699 6.73622 7.26395 7.33317 8.00033 7.33317Z",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8269 3.17329C11.1988 3.54478 11.4938 3.98593 11.6951 4.47153C11.8964 4.95712 12 5.47763 12 6.00329C12 6.52895 11.8964 7.04946 11.6951 7.53505C11.4938 8.02064 11.1988 8.46179 10.8269 8.83329M5.17354 8.82662C4.80163 8.45513 4.5066 8.01397 4.3053 7.52838C4.104 7.04279 4.00039 6.52228 4.00039 5.99662C4.00039 5.47096 4.104 4.95045 4.3053 4.46486C4.5066 3.97927 4.80163 3.53811 5.17354 3.16662M12.7135 1.28662C13.9633 2.53681 14.6654 4.23219 14.6654 5.99995C14.6654 7.76772 13.9633 9.4631 12.7135 10.7133M3.28687 10.7133C2.03706 9.4631 1.33496 7.76772 1.33496 5.99995C1.33496 4.23219 2.03706 2.53681 3.28687 1.28662",
    stroke: "#537089",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastGrey);
export default __webpack_public_path__ + "static/media/broadcast-grey.a054f69f9b247e8f60b39812097b5c69.svg";
export { ForwardRef as ReactComponent };